/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeePayPeriodJobRoleRate
 */
export interface EmployeePayPeriodJobRoleRate {
    /**
     * 
     * @type {number}
     * @memberof EmployeePayPeriodJobRoleRate
     */
    totalPaidHours: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePayPeriodJobRoleRate
     */
    rate: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePayPeriodJobRoleRate
     */
    estimatedTotal: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeePayPeriodJobRoleRate
     */
    roleAndTypeDescription: string;
    /**
     * 
     * @type {number}
     * @memberof EmployeePayPeriodJobRoleRate
     */
    jobRoleId: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePayPeriodJobRoleRate
     */
    payTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeePayPeriodJobRoleRate
     */
    payCode: string;
}

/**
 * Check if a given object implements the EmployeePayPeriodJobRoleRate interface.
 */
export function instanceOfEmployeePayPeriodJobRoleRate(value: object): value is EmployeePayPeriodJobRoleRate {
    if (!('totalPaidHours' in value) || value['totalPaidHours'] === undefined) return false;
    if (!('rate' in value) || value['rate'] === undefined) return false;
    if (!('estimatedTotal' in value) || value['estimatedTotal'] === undefined) return false;
    if (!('roleAndTypeDescription' in value) || value['roleAndTypeDescription'] === undefined) return false;
    if (!('jobRoleId' in value) || value['jobRoleId'] === undefined) return false;
    if (!('payTypeId' in value) || value['payTypeId'] === undefined) return false;
    if (!('payCode' in value) || value['payCode'] === undefined) return false;
    return true;
}

export function EmployeePayPeriodJobRoleRateFromJSON(json: any): EmployeePayPeriodJobRoleRate {
    return EmployeePayPeriodJobRoleRateFromJSONTyped(json, false);
}

export function EmployeePayPeriodJobRoleRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeePayPeriodJobRoleRate {
    if (json == null) {
        return json;
    }
    return {
        
        'totalPaidHours': json['totalPaidHours'],
        'rate': json['rate'],
        'estimatedTotal': json['estimatedTotal'],
        'roleAndTypeDescription': json['roleAndTypeDescription'],
        'jobRoleId': json['jobRoleId'],
        'payTypeId': json['payTypeId'],
        'payCode': json['payCode'],
    };
}

  export function EmployeePayPeriodJobRoleRateToJSON(json: any): EmployeePayPeriodJobRoleRate {
      return EmployeePayPeriodJobRoleRateToJSONTyped(json, false);
  }

  export function EmployeePayPeriodJobRoleRateToJSONTyped(value?: EmployeePayPeriodJobRoleRate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPaidHours': value['totalPaidHours'],
        'rate': value['rate'],
        'estimatedTotal': value['estimatedTotal'],
        'roleAndTypeDescription': value['roleAndTypeDescription'],
        'jobRoleId': value['jobRoleId'],
        'payTypeId': value['payTypeId'],
        'payCode': value['payCode'],
    };
}

